/* eslint-disable no-param-reassign */ /* eslint-disable radix */ /*
eslint-disable radix */
<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Save"
      back-button-text="Previous"
      class="mb-3"
      @on-complete="formSubmitted"
    >
      <b-button
        v-if="$can('create', 'Roles')"
        variant="primary"
        :to="{ name: 'accountManagement-create-role' }"
      >
        <span class="text-nowrap">Add New</span>
      </b-button>
      <!-- accoint details tab -->
      <tab-content
        title="Edit Role"
        icon="feather icon-file-text"
        :before-change="validationForm"
      >
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">
                Role Details
              </h5>
              <small class="text-muted"> Enter Role Details. </small>
            </b-col>
            <!-- Name -->
            <b-col md="6">
              <b-form-group label="Name" label-for="name">
                <validation-provider name="name">
                  <b-form-input id="name" v-model="requestData.name" disabled />
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Description -->
            <b-col md="6">
              <b-form-group label="Description *" label-for="Description">
                <validation-provider name="Description">
                  <b-form-textarea
                    id="textarea-default"
                    v-model="requestData.description"
                    placeholder="description"
                    rows="3"
                    disabled
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Module and controllers -->
          <div v-for="(data, key) in privileges" :key="key">
            <b-card
              border-variant="secondary"
              :title="data.name"
              bg-variant="transparent"
              class="shadow-none"
            >
              <b-card-text>
                <div v-for="(value, index) in data.controllers" :key="index">
                  <b-row>
                    <b-col md="6" xl="4">
                      {{ value.name }}
                    </b-col>
                    <b-col md="6" xl="4">
                      <b-form-checkbox
                        v-model="value.isChecked"
                        :indeterminate.sync="value.isIndeterminate"
                        @change="handleCheckAllChange(value)"
                      >
                        Full Access
                      </b-form-checkbox>
                    </b-col>
                    <b-col md="6" xl="4">
                      <b-form-group
                        v-model="checkedPrivileges"
                        label-for="isCheked"
                      >
                        <b-form-checkbox
                          v-for="(item, i) in value.morePermissions"
                          :key="i"
                          v-model="item.isChecked"
                          @change="handleCheckedChange(item, value)"
                        >
                          {{ item.name }}
                        </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-card-text>
            </b-card>
          </div>
        </validation-observer>
      </tab-content>
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "@axios";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BOverlay,
  BFormInvalidFeedback,
  BCard,
  BDropdown,
  BFormCheckbox,
  BCardText,
} from "bootstrap-vue";
import { required } from "@validations";

export default {
  name: "AddLandlord",
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BOverlay,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    vSelect,
    BFormTextarea,
    BCard,
    BDropdown,
    BFormCheckbox,
    BCardText,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      isLoading: false,
      requestData: {},
      accessTypes: [
        { id: 1, name: "GateWay" },
        { id: 2, name: "Merchant" },
      ],
      required,
      privileges: [],
      checkedPrivileges: [],
      allPrivilegeCounter: 0,
    };
  },
  created() {
    this.getRoleById();
    // this.privileges = JSON.parse(localStorage.getItem('modules'))
    console.log(this.privileges);
    this.privileges.forEach((res) => {
      res.controllers.forEach((item) => {
        item.isChecked = false;
        item.isIndeterminate = false;
        item.actions.forEach((val) => {
          val.isChecked = false;
        });
        item.morePermissions.forEach((val) => {
          val.isChecked = false;
        });
      });
    });
  },
  methods: {
    formSubmitted() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Data Submitted",
          icon: "EditIcon",
          variant: "success",
        },
      });
    },
    // Privileges
    handleCheckAllChange(val) {
      if (!val.isChecked) {
        val.isChecked = false;
        val.isIndeterminate = false;
        val.actions.forEach((res) => {
          res.isChecked = false;
          if (this.checkedPrivileges.find((el) => el === res.id)) {
            const arr = this.checkedPrivileges.find((el) => el === res.id);
            this.checkedPrivileges.splice(
              this.checkedPrivileges.indexOf(arr),
              1
            );
          }
        });
        val.morePermissions.forEach((res) => {
          res.isChecked = false;
          if (this.checkedPrivileges.find((el) => el === res.id)) {
            const arr = this.checkedPrivileges.find((el) => el === res.id);
            this.checkedPrivileges.splice(
              this.checkedPrivileges.indexOf(arr),
              1
            );
          }
        });
      } else {
        val.isChecked = true;
        val.isIndeterminate = false;
        val.actions.forEach((res) => {
          res.isChecked = true;
          this.checkedPrivileges.push(res.id);
        });
        val.morePermissions.forEach((res) => {
          res.isChecked = true;
          this.checkedPrivileges.push(res.id);
        });
      }
      // Remove Duplication
      this.checkedPrivileges = [...new Set(this.checkedPrivileges)];
    },
    handleCheckedChange(role, privileges) {
      if (this.checkedPrivileges.find((el) => el === role.id)) {
        const arr = this.checkedPrivileges.find((el) => el === role.id);
        this.checkedPrivileges.splice(this.checkedPrivileges.indexOf(arr), 1);
        console.log(this.checkedPrivileges);
        const tempData1 = [];
        if (privileges.actions.length > 0) {
          privileges.actions.forEach((res) => {
            this.checkedPrivileges.forEach((val) => {
              if (res.id === val) {
                tempData1.push(res.id);
              }
            });
          });
        }
        if (privileges.morePermissions.length > 0) {
          privileges.morePermissions.forEach((res) => {
            this.checkedPrivileges.forEach((val) => {
              if (res.id === val) {
                tempData1.push(res.id);
              }
            });
          });
        }
        if (
          tempData1.length ===
          privileges.actions.length + privileges.morePermissions.length
        ) {
          privileges.isChecked = true;
          privileges.isIndeterminate = false;
        } else if (tempData1.length === 0) {
          privileges.isChecked = false;
          privileges.isIndeterminate = false;
        } else {
          privileges.isChecked = false;
          privileges.isIndeterminate = true;
        }
      } else {
        this.checkedPrivileges.push(role.id);
        const tempData2 = [];
        privileges.actions.forEach((res) => {
          this.checkedPrivileges.forEach((val) => {
            if (res.id === val) {
              tempData2.push(res.id);
            }
          });
        });
        privileges.morePermissions.forEach((res) => {
          this.checkedPrivileges.forEach((val) => {
            if (res.id === val) {
              tempData2.push(res.id);
            }
          });
        });
        if (
          tempData2.length ===
          privileges.actions.length + privileges.morePermissions.length
        ) {
          privileges.isChecked = true;
          privileges.isIndeterminate = false;
        } else if (tempData2.length === 0) {
          privileges.isChecked = false;
          privileges.isIndeterminate = false;
        } else {
          privileges.isChecked = false;
          privileges.isIndeterminate = true;
        }
      }
    },
    setDefault() {
      this.privileges.forEach((res) => {
        res.controllers.forEach((item) => {
          let counter1 = 0;
          item.actions.forEach((val) => {
            if (this.checkedPrivileges.find((iv) => val.id === iv)) {
              counter1 += 1;
              val.isChecked = true;
              this.allPrivilegeCounter += 1;
            }
          });
          item.morePermissions.forEach((val) => {
            if (this.checkedPrivileges.find((iv) => val.id === iv)) {
              val.isChecked = true;
              counter1 += 1;
              this.allPrivilegeCounter += 1;
            }
          });
          if (counter1 === item.actions.length + item.morePermissions.length) {
            item.isChecked = true;
            item.isIndeterminate = false;
          } else if (counter1 > 0) {
            item.isChecked = false;
            item.isIndeterminate = true;
          } else if (counter1 === 0) {
            item.isChecked = false;
            item.isIndeterminate = false;
          }
        });
      });
      // this.requestData.accessType = this.accessTypes.filter(c => c.id === this.requestData.accessType)
    },
    // Call API For persistency
    getRoleById() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "ClientRole-Update");
      axios
        .get("/ClientUser/api/V1.0/ClientPrivilege/GetGroupPrivilege")
        .then((res) => {
          this.privileges = res.modules; // JSON.parse(localStorage.getItem('modules'))

          axios
            .get(
              `/User/api/V1.0/ClientRole/GetById?Id=${this.$route.params.id}`
            )
            .then((res) => {
              res.role.privileges.forEach((val) => {
                this.checkedPrivileges.push(val.id);
              });
              // res.role.modules.forEach(val => {
              //   this.checkedCompanies.push(val.id)
              // })
              this.requestData.name = res.role.name;
              this.requestData.description = res.role.description;
              this.requestData.roleId = res.role.id;
              this.requestData.privileges = res.role.privileges;

              // this.accessTypes.id = res.rol.accessType
              // this.requestData.accessType = res.role.accessType
              // console.log(res.role.accessType)
              this.requestData.accessType = this.accessTypes.find(
                (en) => en.id === res.role.accessType
              );

              this.requestData.privileges = [];
              this.requestData.companies = [];
              this.setDefault();
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        });
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success) {
            if (this.checkedPrivileges.length > 0) {
              this.requestData.privileges = this.checkedPrivileges;
              this.isLoading = true;
              axios
                .post(
                  "/api/DatabaseSeeding/AddClientRolePrivilege",
                  this.requestData
                )
                .then(() => {
                  resolve(true);
                  this.$router.push("/account-Management/client-roles");
                })
                .catch((err) => {
                  reject(err);
                  this.isLoading = false;
                });
            } else {
              console.log("Display Error Type");
            }
          } else {
            reject();
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
